import { createStore, createEvent } from 'effector';

export const $isAuth = createStore(false);

export const setIsAuth = createEvent();

$isAuth
    .on(setIsAuth, (_, value) => value);